module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_26_A_1.a5f5fe40.mp3";